import { render, staticRenderFns } from "./IndexReport.vue?vue&type=template&id=25139213&scoped=true"
import script from "./IndexReport.vue?vue&type=script&lang=js"
export * from "./IndexReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25139213",
  null
  
)

export default component.exports